export enum ApartmentRouteContextKey {
  Block = 'block',
  Level = 'level',
  Unit = 'unit',
}

export enum HouseAndLandRouteContextKey {
  Precinct = 'precinct',
  Stage = 'stage',
  Lot = 'lot',
}

export interface ApartmentRouteContext {
  [ApartmentRouteContextKey.Block]?: string
  [ApartmentRouteContextKey.Level]?: string
  [ApartmentRouteContextKey.Unit]?: string
}

export interface HouseAndLandRouteContext {
  [HouseAndLandRouteContextKey.Precinct]?: string
  [HouseAndLandRouteContextKey.Stage]?: string
  [HouseAndLandRouteContextKey.Lot]?: string
}
